import { FC } from 'react';
import { FormikProps } from 'formik';

import { TextAreaFormikWrapper } from 'core/components/forms/TextArea';
import { ITextArea } from 'core/components/forms/TextArea/TextArea';
import { ErrorIcon } from 'assets/img';

import './style.scss';

interface ITextAreaFieldFormProps {
  formikProps: FormikProps<any>;
}

export const TextAreaFieldForm: FC<ITextAreaFieldFormProps & ITextArea> = (props) => {
  const { formikProps, ...rest } = props;

  return (
    <TextAreaFormikWrapper
      {...rest}
      formikProps={formikProps}
      children={
        <>
          {rest.children}
          <ErrorIcon className={'error-icon'} />
        </>
      }
      onBlur={() => {
        if (!formikProps.touched[rest.name]) {
          formikProps.setFieldTouched(rest.name);
        }
      }}
    />
  );
};
